


$(document).ready(function () {
    document.querySelectorAll('.newstabs li').forEach(tab => {
        tab.addEventListener('click', function () {
            const target = this.getAttribute('data-tab');
            switchTab(target);
            document.querySelector('.newstab-select').value = target; // sync select
        });
    });
});

function switchTab(tabId) {
    document.querySelectorAll('.newstabs li').forEach(li => li.classList.remove('active'));
    document.querySelectorAll('.newstab-content').forEach(c => c.classList.remove('active'));

    const activeTab = document.querySelector(`[data-tab="${tabId}"]`);
    if (activeTab) activeTab.classList.add('active');

    document.getElementById(tabId).classList.add('active');
}

$(document).ready(function () {
    var owl = $('.centercaro.owl-carousel');
    owl.owlCarousel({
        center: true,
        margin: 20,
        dots: true,
        dotsEach: false,
        //autoplay: true,
        //autoplayTimeout: 1800,
        //autoplayHoverPause: true,
        nav: false,
        loop: true,
        responsive: {
            1: {
                items: 1,
                stagePadding: 40,
                autoplay: true,
                dots: false,
                margin: 10,
            },
            475: {
                items: 1,
                stagePadding: 30,
                autoplay: true,
                dots: false,
                margin: 10,
            },
            600: {
                items: 2,
                stagePadding: 50,
                autoplay: true,
                dots: false,
                margin: 10,
            },
            768: {
                items: 2,
            },
            992: {
                items: 2,
            },
            1200: {
                items: 2,
            }
        }
    });
});


$(document).ready(function () {
    var owl = $('.charCaro.owl-carousel');
    owl.owlCarousel({
        margin: 10,
        dots: false,
        dotsEach: false,
        autoHeight: false,
        autoplay: true,
        autoplayTimeout: 1800,
        autoplayHoverPause: true,
        nav: false,
        loop: true,
        responsive: {
            1: {
                items: 1
            },
            400: {
                items: 2
            },
            575: {
                items: 2
            },
            640: {
                items: 3
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            },
            1200: {
                items: 6
            }
        }
    });
});

(function () {
    const target = document.querySelector('.g-recaptcha');

    if (!target) return;

    const observer = new MutationObserver(function () {
        const badge = document.querySelector('.grecaptcha-badge');

        if (badge) {
            target.appendChild(badge);
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();

/* The sub menu expand toggles are spans with role="button", so they are in the
   tab order but Bootstrap 5.1 only binds Arrow/Escape to a dropdown toggle -
   Enter and Space would otherwise do nothing on them. */
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (!e.target || typeof e.target.closest !== 'function') return;

    const toggle = e.target.closest('.dropdown-submenu > .drop-arw');

    if (!toggle) return;

    e.preventDefault();
    toggle.click();
});


/* Sub menu hover / click behaviour:

     - hovering the row (label or chevron) expands it, and moving the pointer
       off the row collapses it again;
     - clicking the chevron pins it open, and it stays open until it is
       clicked a second time.

   Pointer devices only: on touch, mouseenter fires alongside the tap, so the
   hover would open the sub level and the tap would immediately close it.
   Plain Bootstrap click-to-toggle already does the right thing there. */
(function () {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    if (!window.bootstrap || !window.bootstrap.Dropdown) return;

    /* Rows sit directly above one another, so a pointer on its way to a lower
       one passes straight through the ones above it. A short intent delay
       keeps those pass throughs from expanding everything on the way. */
    const HOVER_INTENT_MS = 120;

    document.querySelectorAll('.dropdown-submenu').forEach(function (item) {
        const toggle = item.querySelector(':scope > .drop-arw');

        if (!toggle) return;

        let timer = null;
        let pinned = false;

        const isOpen = function () {
            return toggle.getAttribute('aria-expanded') === 'true';
        };

        const dropdown = function () {
            return window.bootstrap.Dropdown.getOrCreateInstance(toggle);
        };

        /* The li covers the row and, once open, the expanded list underneath
           it - so the pointer can travel down into the items that just
           appeared without tripping the mouseleave that would close them. */
        item.addEventListener('mouseenter', function () {
            window.clearTimeout(timer);

            if (isOpen()) return;

            timer = window.setTimeout(function () {
                dropdown().show();
            }, HOVER_INTENT_MS);
        });

        item.addEventListener('mouseleave', function () {
            window.clearTimeout(timer);

            if (pinned || !isOpen()) return;

            dropdown().hide();
        });

        /* Bootstrap binds its own toggle handler on the document, so this
           runs first and aria-expanded is still the pre-click state. */
        toggle.addEventListener('click', function (e) {
            window.clearTimeout(timer);

            if (isOpen() && !pinned) {
                /* Already open from hover. Someone clicking it means "keep
                   this", not "close this", so pin it and let Bootstrap's
                   handler never see the click. */
                pinned = true;
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            pinned = !isOpen();
        });

        /* Closed by anything else - a second click, Escape, the parent menu
           closing - so drop the pin and let hover take over again. */
        toggle.addEventListener('hidden.bs.dropdown', function () {
            pinned = false;
        });
    });
})();
